import {ConfigStructure} from "./config-structure.model";

export class TabConfigStructure {

  constructor(public titleKey: string, public config: ConfigStructure[], public defaultTab: boolean = false) {

  }
}
